/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useRef, useState,useEffect, useCallback, useContext } from 'react';
import CardHeader from "../../../components/CardHeader"
import Table from './Components/Table'
import { useSearchParams } from 'react-router-dom'
import Search from './../TopBarComponents/Search'
import Filter from './Components/Filter'
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { dataService } from '../../../services/data.services';
import Debounce from '../../../CommonMethods/Debounce';
import Shimmer from '../../../components/Shimmer/itemShimmer'
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import EmptyAddScreen from '../../../components/EmptyAddScreen'
import GlobalContext from '../../../components/Context/GloablContext';
import Toast from '../../../components/Toast';
import { formatAdjustedDate } from '../../../CommonMethods/formatDate';
import Loader from '../../../components/Loader';
import moment from 'moment';

const InventoryStockReport = () => {
    const {setToastmessage, reloadFY, setReloadFY} = useContext(GlobalContext);
    const [searchParams, setSearchParams] = useSearchParams()
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const [reportDate, setReportDate] = useState(new Date());
    const [InventoryStockReportList, setInventoryStockReportList] = useState([])
    const [InventoryStockReportCount, setInventoryStockReportCount] = useState(0)
    const [InventoryStockReportTotalCount, setInventoryStockReportTotalCount] = useState(0)
    const [loading, setLoading] =useState(true) 
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    const [FilterData, setFilterData] = useState({date_range : [],});
    const [filterCount, setFilterCount] = useState(0)
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [selectedFilter, setSelectedFilter] = useState(Object.keys(FilterData !==undefined&& FilterData)[0]||'city');
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [exportBtnLoading, setExportBtnLoading] = useState(false)

    const outSideClick = useRef();

    /**
     * The `formatDate` function takes an input date string and returns it in the format "YYYY-MM-DD".
     * @returns The function `formatDate` returns a formatted date string in the format "YYYY-MM-DD".
     */
    const formatDate = (inputDateString) => {
        const inputDate = new Date(inputDateString);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    /**
     * The function `exportBtnhandler` calls an API to get data for an inventory issue report export.
     */
    const exportBtnhandler = () => {
        if ( loading || exportBtnLoading) {
            return;
        }
        if (InventoryStockReportCount === 0) {
            setToastErrorMessage("No records to export");
            return;
        }
        getExportDataForInventoryStockReportAPICall()
    }
    
    //Fliter Functions----
    /**
     * The function `updateFilterCheckBox` creates an object with non-null properties from searchParams,
     * filters out null or undefined values, updates the state with the filtered values, and counts the
     * number of filtered values.
     */
    const updateFilterCheckBox = () => {
        // Create an object with non-null properties from searchParams
        const filterState = {
            report_date: searchParams.get('report_date'),
        };
        // Filter out null or undefined values
        const filteredFilterState = Object.fromEntries(
            Object.entries(filterState).filter(([_, value]) => value !== null && value !== undefined)
        );
        // Update the state with the filtered values
        setFilterCheckBox(filteredFilterState);
        let count = 0
        Object.keys(filteredFilterState).map((item) =>  {
            if(filteredFilterState[item] &&filteredFilterState[item]?.length !== 0) {
                count += 1
            }
        })
        setFilterCount(count)
    };
    /**
     * The function `getCount` counts the number of non-empty values in the `FilterCheckbox` object and
     * updates the `filterCount` state variable accordingly.
     */
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item] &&FilterCheckbox[item]?.length !== 0) {
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)
        } else {
            setFilterCount(0)
        }
    }
    /**
     * The function `handleOpenFilter` updates the filter values based on the search parameters and toggles
     * the filter open state.
     */
    const handleOpenFilter = () => {
        let filter_val = {}
        Object.keys(FilterData).map((item) => {
            let params = Object.fromEntries(searchParams);
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    filter_val[item] = params[item].split(',')
                }
                if(subitem==='report_date'){
                    filter_val[subitem]=params[subitem]
                }
            })
            setFilterCheckBox(filter_val)      
        })
        setIsFilterOpen((prevState)=> !prevState)
        setSelectedFilter('date_range')
    }
    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specific
    element. In this case, it is used to detect clicks outside of the filter component. When a click is
    detected outside of the filter component, the callback function `() => { setIsFilterOpen(false) }`
    is executed, which sets the `isFilterOpen` state to `false`, closing the filter component. */
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    /**
     * The function `handleSelectObject` updates the state of `FilterCheckbox` based on the selected
     * object's id, dateString, and selectedFilter.
     */
    const handleSelectObject = (id,dateString,selectedFilter) => {
        if(id === 'report_date') {
            setFilterCheckBox((prv)=>({
                ...prv,
                [id]: dateString
            }))
        }  else {
            setFilterCheckBox((prv)=>({
                ...prv,
                [selectedFilter]:[id]
            }))
        } 
    }
    /**
     * The function `handleApplyFilter` is used to apply filters to a search query and update the search
     * parameters accordingly.
     */
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if(type) {
            setSearchParams({ ...params})
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                let val = ""
                if((item === 'report_date') && FilterCheckbox[item]!==null) {
                    let val = FilterCheckbox[item]
                    params[item] = searchParams.get(item) !== val ? formatDate(val) : val
                    setSearchParams({ ...params})
                    flag = false
                } else if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 ) {
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`
                    })
                    params[item] = val.slice(0, -1) 
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
        } else {
            const searchParam = searchParams.get('search');
            searchParam !== null ? setSearchParams({'search': searchParam}) : setSearchParams({});            
            setFilterCheckBox([]);
        }
        getCount(type)
    }
    //----

    //Search Functions ----
    /**
     * The function `handleSearchParams` updates the search parameters by adding or modifying a key-value
     * pair, and then updates the state with the new search parameters.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value);}
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
    /* The `optimizedFn` is a memoized version of the `Debounce` function that is used to debounce the
    `handleSearchParams` function. Debouncing is a technique used to limit the number of times a
    function is called by delaying its execution until after a certain amount of time has passed since
    the last time it was invoked. */
    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );
    //----
    const calculateEndDate = (fyEndDate) => {
        const fyEndDate1 = new Date(fyEndDate);
        const currentDate = moment().endOf('day');
        return currentDate <= fyEndDate1 ? currentDate.toISOString() : fyEndDate;
    }

    //API Calls----

    /* The above code is a JavaScript React function using the `useCallback` hook to make an API call to
    retrieve inventory issue report data. Here is a breakdown of what the code is doing: */
    const getInventoryStockReportListAPICall = useCallback(async () => {
        if(searchParams?.get('search') === null){
            setsearchFieldDebounce('')
        }

        const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
        const reportDate1 = calculateEndDate(selectedFY.end_date);
        
        setReportDate(reportDate1)
        
        let report_date = searchParams?.get('report_date');
        if (report_date) {
            const parsedEndDate = new Date(report_date);
            parsedEndDate.setDate(parsedEndDate.getDate());
            report_date = parsedEndDate.toISOString().split('T')[0];
        }
        try {   
            setLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `inventory/stock-report?branch_id=${branch_id}&page_number=${
                searchParams?.get('page_number')===null ? '1' : searchParams?.get('page_number')}${
                searchParams?.get('search') === null ? '': `&search=${encodeURIComponent(searchParams?.get('search'))}` }${`${
                searchParams?.get('report_date') === null ? `&date=${reportDate1.substring(0,10)}` : `&date=${report_date}`}`}${
                searchParams?.get('sort') === null 
                    ? '' 
                    : `&sort=${encodeURIComponent(searchParams.get('sort'))}`
            }`
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data?.data
            const temp2 = response?.data?.data?.total_count
            const temp3 = response?.data?.data?.all_total_count
            setInventoryStockReportList(temp)
            setInventoryStockReportCount(temp2)
            setInventoryStockReportTotalCount(temp3)    
        } catch(error) {
            console.log(error)
            setLoading(false)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } finally{
            setLoading(false)
            updateFilterCheckBox();
        }
    }, [searchParams]);

    /**
     * The function `getExportDataForInventoryStockReportAPICall` makes an API call to retrieve data for
     * Inventory Issue Report and opens a new window with the pre-signed URL for exporting the data.
     */
    const getExportDataForInventoryStockReportAPICall = async() => {
        
        let report_date = searchParams?.get('report_date');
        if (report_date) {
            const parsedEndDate = new Date(report_date);
            parsedEndDate.setDate(parsedEndDate.getDate());
            report_date = parsedEndDate.toISOString().split('T')[0];
        }
        try{
            setExportBtnLoading(true)
            const branch_id = await GetBranchId()
            let endpoint = `inventory/stock-report?branch_id=${branch_id}&export=true${`${
                searchParams?.get('search') === null ? '': `&search=${encodeURIComponent(searchParams?.get('search'))}` }${
                searchParams?.get('report_date') === null ? `&date=${(reportDate.substring(0,10))}` : `&date=${report_date}`}`}`;
            const response = await dataService.GetAPI(endpoint)
            setToastmessage(response?.data?.data?.message)
            window.open(response?.data?.data?.pre_signed_url)
        } catch(error) {
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log(error)
            setExportBtnLoading(false)
        } finally {
            setExportBtnLoading(false)
        }
    }
    //----
        
    /* The below code is using the `useEffect` hook in React to make an API call to
    `getInventoryStockReportListAPICall` function. This API call is made when the component is mounted
    or when the `getInventoryStockReportListAPICall` function changes. */
    useEffect(()=>{
        getInventoryStockReportListAPICall()
    },[getInventoryStockReportListAPICall])

    useEffect(() => {
        if (reloadFY) {
            handleApplyFilter(false)
            
            window.location.reload();
            setReloadFY(false);
        }
    }, [reloadFY]);

    return (
        <CardHeader noPadding>
            {/* top bar */}
            <div
                className="mainDataCntnrTop shadow-s13"
                style={{ position: "sticky", position: "-webkit-sticky"}}
            >
                <div className="flex justify-start">
                    <h5 class=" pageHeader adderror">
                        Inventory Stock Report
                    </h5>
                </div> 
                <div className='flex items-center'>
                    <Search
                        SearchValue={searchFieldDebounce}
                        handleOnClickSearch={setsearchFieldDebounce}
                        optimizedFn={optimizedFn}
                        customSearchPlaceHolder={'Item Name / Code'}
                    />
                    <div class="relative">
                        <button onClick={() => {
                            handleOpenFilter()

                        }} type="button" id="filter_btn">
                            <img loading="lazy" src="/images/Filter_Icon.svg" alt="img" class="w-[15px] h-[15px]"/>
                            <span class="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                            {filterCount !== 0 && <p class="p-2 text-[14px] leading-[7px] font-semibold text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">{filterCount}</p>}
                        </button>
                        {isFilterOpen && 
                        <Filter 
                            filterCount={filterCount}
                            dateRangeFilterName={'Stock Report Date'}
                            searchParams={searchParams}
                            ref={outSideClick}
                            handleSelectObject={handleSelectObject}
                            FilterCheckbox={FilterCheckbox}
                            setFilterCheckBox={setFilterCheckBox} 
                            FilterData={FilterData}
                            handleApplyFilter={handleApplyFilter}
                            setIsFilterOpen={setIsFilterOpen}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}  
                            radioButton={true}   
                            setSearchParams={setSearchParams} 
                            setReportDate={setReportDate}  
                            dateRangeDropdownOptions={[{ name: 'Financial Year' }, { name: 'Custom' }]} 
                        />}
                    </div>
                    <button onClick={exportBtnhandler} id='export'
                        className={`prmy-btn`}>
                        {exportBtnLoading ? <Loader /> : 'Export'}
                    </button>
                </div>
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            <div class="mainDataCntnrListDiv scrollBlue_thick">
                { loading 
                    ? <div className="mt-[32px]"><Shimmer/></div> 
                    : <Table reportDate={reportDate} InventoryStockReportStudentList={InventoryStockReportList} setPageLoading={setLoading} searchParams={searchParams} setSearchParams={setSearchParams} InventoryStockReportStudentCount={InventoryStockReportCount} handleOnClickSort={handleSearchParams} sortValue={searchParams.get('sort') || ''} />}
            </div>
        </CardHeader>
    )
}

export default InventoryStockReport;